/* payModule  1:order  2:refund*/

export function payByWechat(payModule, id, redirectUrl = '') {
  return {
    type: 'PAY_BY_WECHAT',
    payModule,
    id,
    redirectUrl,
  };
}

export function payByWechatCompletion(payModule, id, error = null) {
  return {
    type: 'PAY_BY_WECHAT_COMPLETION',
    payModule,
    id,
    error,
  };
}

export function payByWallet(payModule, id, payPass = '') {
  return {
    type: 'PAY_BY_WALLET',
    payModule,
    id,
    payPass,
  };
}

export function payByWalletCompletion(payModule, id, error = null) {
  return {
    type: 'PAY_BY_WALLET_COMPLETION',
    payModule,
    id,
    error,
  };
}
